/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RequisicaoFormAliases {
  ACCORDION_0 = 'accordion-0',
  ACCORDION_ANEXO = 'accordion-anexo',
  ACCORDION_GLOSA_OCORRENCIA = 'accordion-glosa-ocorrencia',
  ACTION_PRINT = 'action-print',
  ATTACHMENTS_LIST_ANEXO = 'attachments-list-anexo',
  AVATAR_0 = 'avatar-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DECK_0 = 'deck-0',
  FETCH_ANEXO = 'fetch-anexo',
  FETCH_DIAGNOSTICO = 'fetch-diagnostico',
  FETCH_GLOSA_OCORRENCIA = 'fetch-glosa-ocorrencia',
  FETCH_PROD_MAT = 'fetch-prod-mat',
  FETCH_REQUEST_DATA = 'fetch-request-data',
  FIELD_4 = 'field-4',
  FIELD_5 = 'field-5',
  FIELD_6 = 'field-6',
  FIELD_CID = 'field-cid',
  FIELD_DESCRICAO = 'field-descricao',
  FIELD_DESCRICAO_GLOSA_OCORRENCIA = 'field-descricao-glosa-ocorrencia',
  FIELD_DIAGNOSTICO = 'field-diagnostico',
  FIELD_DS_ACOMODACAO = 'field-dsAcomodacao',
  FIELD_DS_CBO_SAUDE = 'field-dsCboSaude',
  FIELD_DS_CNES = 'field-dsCnes',
  FIELD_DS_CNES_EXECUTOR = 'field-dsCnesExecutor',
  FIELD_DS_ESPECIALIDADE = 'field-dsEspecialidade',
  FIELD_DS_ESTAGIO = 'field-dsEstagio',
  FIELD_DS_INDICACAO_CLINICA = 'field-dsIndicacaoClinica',
  FIELD_DS_PROC_MAT = 'field-dsProcMat',
  FIELD_DS_TIPO_ATENDIMENTO_ODONTO = 'field-dsTipoAtendimentoOdonto',
  FIELD_DS_TIPO_INTERNACAO = 'field-dsTipoInternacao',
  FIELD_DT_INTERNACAO_SUGERIDA = 'field-dtInternacaoSugerida',
  FIELD_DT_NASC_RECEM_NASCIDO = 'field-dtNascRecemNascido',
  FIELD_DT_REQUISICAO = 'field-dtRequisicao',
  FIELD_IE_CARATER_ATENDIMENTO = 'field-ieCaraterAtendimento',
  FIELD_IE_REGIME_INTERNACAO = 'field-ieRegimeInternacao',
  FIELD_IE_TIPO_ATENDIMENTO = 'field-ieTipoAtendimento',
  FIELD_IE_TIPO_CONSULTA = 'field-ieTipoConsulta',
  FIELD_IE_TIPO_GUIA = 'field-ieTipoGuia',
  FIELD_NM_BENEFICIARIO = 'field-nmBeneficiario',
  FIELD_NM_MEDICO_SOLIC = 'field-nmMedicoSolic',
  FIELD_NM_PRESTADOR_EXEC = 'field-nmPrestadorExec',
  FIELD_NM_PRESTADOR_SOLIC = 'field-nmPrestadorSolic',
  FIELD_NM_RECEM_NASCIDO = 'field-nmRecemNascido',
  FIELD_NR_PROTOCOLO = 'field-nrProtocolo',
  FIELD_NR_SEQ_REQUISICAO = 'field-nrSeqRequisicao',
  FIELD_QT_AUTORIZADA = 'field-qtAutorizada',
  FIELD_QT_DIA_SOLICITADO = 'field-qtDiaSolicitado',
  FIELD_QT_SOLICITADA = 'field-qtSolicitada',
  FIELDSET_0 = 'fieldset-0',
  FIELDSET_CID = 'fieldset-cid',
  FIELDSET_GUIA_INTERNACAO = 'fieldset-guia-internacao',
  FIELDSET_RECEM_NASCIDO = 'fieldset-recem-nascido',
  FORM_CID = 'form-cid',
  HPMS_CUSTOM_CARD_CONTENT_COLLAPSE = 'hpms-custom-card-content-collapse',
  HPMS_CUSTOM_CARD_PROCEDIMENTO_MATERIAL = 'hpms-custom-card-procedimento-material',
  HPMS_DYNAMIC_ACTION = 'hpms-dynamic-action',
  HPMS_DYNAMIC_STAMP = 'hpms-dynamic-stamp',
  INPUT_DT_INTERNACAO_SUGERIDA = 'input-dtInternacaoSugerida',
  INPUT_DT_REQUISICAO = 'input-dtRequisicao',
  INPUT_IE_CARATER_ATENDIMENTO = 'input-ieCaraterAtendimento',
  INPUT_IE_REGIME_INTERNACAO = 'input-ieRegimeInternacao',
  INPUT_IE_TIPO_ATENDIMENTO = 'input-ieTipoAtendimento',
  INPUT_IE_TIPO_CONSULTA = 'input-ieTipoConsulta',
  INPUT_IE_TIPO_GUIA = 'input-ieTipoGuia',
  LAYOUT_0 = 'layout-0',
  LAYOUT_REQUISICAO_FORM = 'layout-requisicao-form',
  MAPPER_0 = 'mapper-0',
  MAPPER_ANEXO = 'mapper-anexo',
  PANEL_1 = 'panel-1',
  PANEL_ANEXO = 'panel-anexo',
  PANEL_CID = 'panel-cid',
  PANEL_CID_CTRL = 'panel-cid-ctrl',
  PANEL_GLOSA_OCORRENCIA = 'panel-glosa-ocorrencia',
  PANEL_GLOSA_OCORRENCIA_CONTENT = 'panel-glosa-ocorrencia-content',
  PANEL_PROD_MAT = 'panel-prod-mat',
  PANEL_REQUISICAO_FORM = 'panel-requisicao-form',
  REPEATER_GLOSA_OCORRENCIA = 'repeater-glosa-ocorrencia',
  REPEATER_REQUEST_DIAGNOSIS = 'repeater-request-diagnosis',
  REQUEST_DATA_FORM = 'requestDataForm',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_ANEXO_TITILE = 'text-anexo-titile',
  TEXT_DESCRICAO = 'text-descricao',
  TEXT_DESCRICAO_GLOSA_OCORRENCIA = 'text-descricao-glosa-ocorrencia',
  TEXT_DIAGNOSTICO = 'text-diagnostico',
  TEXT_DS_ACOMODACAO = 'text-dsAcomodacao',
  TEXT_DS_CBO_SAUDE = 'text-dsCboSaude',
  TEXT_DS_CNES = 'text-dsCnes',
  TEXT_DS_CNES_EXECUTOR = 'text-dsCnesExecutor',
  TEXT_DS_ESPECIALIDADE = 'text-dsEspecialidade',
  TEXT_DS_ESTAGIO = 'text-dsEstagio',
  TEXT_DS_INDICACAO_CLINICA = 'text-dsIndicacaoClinica',
  TEXT_DS_TIPO_INTERNACAO = 'text-dsTipoInternacao',
  TEXT_DT_NASC_RECEM_NASCIDO = 'text-dtNascRecemNascido',
  TEXT_HEADER_GLOSA_OCORRENCIA = 'text-header-glosa-ocorrencia',
  TEXT_NM_BENEFICIARIO = 'text-nmBeneficiario',
  TEXT_NM_MEDICO_SOLIC = 'text-nmMedicoSolic',
  TEXT_NM_PRESTADOR_EXEC = 'text-nmPrestadorExec',
  TEXT_NM_PRESTADOR_SOLIC = 'text-nmPrestadorSolic',
  TEXT_NM_RECEM_NASCIDO = 'text-nmRecemNascido',
  TEXT_NR_PROTOCOLO = 'text-nrProtocolo',
  TEXT_NR_SEQ_REQUISICAO = 'text-nrSeqRequisicao',
  TEXT_QT_AUTORIZADA = 'text-qtAutorizada',
  TEXT_QT_DIA_SOLICITADO = 'text-qtDiaSolicitado',
  TEXT_QT_SOLICITADA = 'text-qtSolicitada',
}
export { RequisicaoFormAliases };
